import { getTodaysDate } from '../util/commonUtil';
import client from './TokenInterceptorServices';

let todaysDate = getTodaysDate();

export const getOpportunitiesDue = async (ROLE, EMAIL, systemDateTime) => {
  // Email Required *
  const URL = `/opportunity/date/${systemDateTime}?role=${ROLE}&email=${EMAIL}`;

  try {
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getForecastSubmittedStatus = async apiPayload => {
  const { email, role, month, year, accountId } = apiPayload;
  let URL; // Make URL Dynamics as per Role
  if (role == 'GCSP') {
    URL = `/opportunity/${role}/forecastsubmitstatus?email=${email}&role=${role}&month=${month}&year=${year}&account_id=${accountId}`;
  } else if (role == 'PL') {
    URL = `/opportunity/forecastsubmitstatus?email=${email}&role=${role}&month=${month}&year=${year}`;
  }

  try {
    const response = await client.get(URL);
    if (role == 'GCSP') {
      return response.data[accountId];
    } else if (role == 'PL') {
      return response.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getUserRole = async EMAIL => {
  const URL = `/opportunity/identifypersona?email=${EMAIL}`;

  try {
    const response = await client.get(URL);
    return response.data; // Comment this line to get hard-coded PL/GCSP role

    // return [] // Uncomment this to see user not authorised condition
    return [
      {
        role: 'PL',
        priority: 6,
        accountList: [
          {
            id: 'f13598d7-6390-ed11-aad1-0022485d1981',
            account_id: 'N.A.',
            name: 'N.A.',
            ey_dunsnumber: null,
          },
        ],
      },
      {
        role: 'GCSP',
        priority: 5,
        accountList: [
          {
            id: null,
            account_id: '7964c49a-d906-ee11-8f6d-0022485d4ca1',
            name: '- ACM - Auto-Service und Umschlag-Center Mosolf GmbH',
            ey_dunsnumber: '327800046',
          },
          {
            id: null,
            account_id: '7d3660b4-bc35-ee11-bdf4-002248e559ce',
            name: 'MegaCorp',
            ey_dunsnumber: null,
          },
        ],
      },
    ];
  } catch (error) {
    throw error;
  }
};

export const getAllRoleQuarterlyData = async (EMAIL, systemDateTime) => {
  // Email Required *
  const URL = `/opportunity/personaquaterlyinfo/${systemDateTime}?email=${EMAIL}`;

  try {
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getDashboardProfileDetails = async EMAIL => {
  const URL = `/opportunity/dashboardProfileDetails?email=${EMAIL}`;
  try {
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Abonded API: Interested person can adopt this API
export const getSystemDateTime = async EMAIL => {
  // Email Required *
  const URL = `/test/systemtime?email=${EMAIL}`;
  try {
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getLogOutStatus = async EMAIL => {
  const URL = `/user/logout?email=${EMAIL}`;
  try {
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getDashboardAllQuartersData = async (EMAIL, YEAR, TODAYS_DATE, ROLE, ACCOUNT_ID) => {
  const URL = `opportunity/rollingYearlyCalculation?email=${EMAIL}&year=${YEAR}&date=${TODAYS_DATE}&role=${ROLE}&account_id=${ACCOUNT_ID}`;
  try {
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getDashboardSingleQuartersData = async (
  ROLE,
  EMAIL,
  YEAR,
  QUARTER,
  TODAYS_DATE,
  ACCOUNT_ID,
  SERVICE,
) => {
  let URL;
  if (ROLE == 'PL') {
    URL = `opportunity/${ROLE}/dashboard/quaterly?email=${EMAIL}&year=${YEAR}&quarter=${QUARTER}&date=${TODAYS_DATE}`;
  } else {
    URL = `opportunity/${ROLE}/dashboard/quaterly?email=${EMAIL}&year=${YEAR}&quarter=${QUARTER}&date=${TODAYS_DATE}&account_id=${ACCOUNT_ID}&service=${SERVICE}`;
  }
  try {
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const userOnboardingSubmit = async REQ_BODY => {
  const URL = `opportunity/useronboarding?email=${REQ_BODY.email}`;
  try {
    const response = await client.post(URL, REQ_BODY);
    return {
      status: response.status,
      msg: response.data.status,
      data: response.data,
    };
  } catch (error) {
    throw error;
  }
};
